import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { KnowledgeBaseArticle, KnowledgeBaseArticleQueryParams, KnowledgeBaseDocument } from '@zayan-erp/home-building';
import { KnowledgeBasePaginationParams } from '@zayan-erp/home-building';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';

@Injectable({
  providedIn: 'root'
})
export class KnowledgeBaseService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  // Article endpoints
  searchArticles(
    searchTerm?: string,
    filters?: KnowledgeBaseArticleQueryParams,
    paginationParams?: KnowledgeBasePaginationParams,
    useSpinner = true
  ): Observable<KnowledgeBaseArticle[]> {
    const params = new URLSearchParams();

    if (paginationParams) {
      params.append('pageNumber', paginationParams.pageNumber.toString());
      params.append('pageSize', paginationParams.pageSize.toString());
    }

    if (searchTerm) {
      params.append('searchTerm', searchTerm);
    }

    if (filters?.status !== undefined && filters?.status !== null) {
      params.append('filters.status', filters.status.toString());
    }

    const queryParams = params.toString() ? `?${params.toString()}` : '';

    return this.#http.getData(`${this.baseUrl}/KnowledgeBase/articles/search${queryParams}`, {
      showLoader: useSpinner,
      showMessage: false
    });
  }

  getArticleById(id: string, useSpinner = true): Observable<KnowledgeBaseArticle> {
    return this.#http.getData(`${this.baseUrl}/KnowledgeBase/articles/${id}`, {
      showLoader: useSpinner,
      showMessage: false
    });
  }

  // Document endpoints
  searchDocuments(
    searchTerm?: string,
    paginationParams?: KnowledgeBasePaginationParams,
    useSpinner = true
  ): Observable<KnowledgeBaseDocument[]> {
    const params = new URLSearchParams();

    // Add search term if provided
    if (searchTerm) {
      params.append('searchTerm', searchTerm);
    }

    if (paginationParams) {
      params.append('pageNumber', paginationParams.pageNumber.toString());
      params.append('pageSize', paginationParams.pageSize.toString());
    }

    const queryParams = params.toString() ? `?${params.toString()}` : '';

    return this.#http.getData(`${this.baseUrl}/KnowledgeBase/documents/search${queryParams}`, {
      showLoader: useSpinner,
      showMessage: false
    });
  }
}
